export default __webpack_public_path__ + "static/media/ReportIcon-Ear-MS.cf04ef33.jpg";